import { userConstants } from "../../constant";

const initialState = {
  buyerRfqs: [],
  manufacturerRfqs: [],
  rfqDetail: null,
  rfqQuotes: [],
  priceSuggestion: null,
};

export function rfq(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_BUYER_RFQS:
      return { ...state, buyerRfqs: action.rfqs };

    case userConstants.CREATE_RFQ:
      return {
        ...state,
        buyerRfqs: [action.rfq, ...state.buyerRfqs],
      };

    case userConstants.GET_RFQ_DETAIL:
      return { ...state, rfqDetail: action.rfq };

    case userConstants.GET_RFQ_QUOTES:
      return { ...state, rfqQuotes: action.quotes };

    case userConstants.GET_MANUFACTURER_RFQS:
      return { ...state, manufacturerRfqs: action.rfqs };

    case userConstants.SUBMIT_RFQ_QUOTE:
      return {
        ...state,
        manufacturerRfqs: state.manufacturerRfqs.map((r) =>
          r.id === action.rfqId ? { ...r, already_quoted: true } : r
        ),
      };

    case userConstants.ACCEPT_RFQ_QUOTE:
    case userConstants.REJECT_RFQ_QUOTE: {
      const updated = action.quote;
      return {
        ...state,
        rfqQuotes: state.rfqQuotes.map((q) =>
          q.id === updated.id ? updated : q
        ),
      };
    }

    case userConstants.SIGN_RFQ_NDA: {
      const rfqData = action.rfq;
      return {
        ...state,
        rfqDetail: rfqData,
        manufacturerRfqs: state.manufacturerRfqs.map((r) =>
          r.id === rfqData.id ? { ...r, nda_signed: true, ...rfqData } : r
        ),
      };
    }

    case userConstants.GET_RFQ_PRICE_SUGGESTION:
      return { ...state, priceSuggestion: action.suggestion };

    default:
      return state;
  }
}
